/* Built In Imports */
import { forwardRef } from 'react';

/* External Imports */
import {
    Box,
    Button,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    useMultiStyleConfig,
    useTab
} from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import FaqSectionV2 from '@components/Accordions/FaqSectionV2';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';
import MidContainer from '@Layout/MidContainer';

/* Services */

/**
 * @param section.section
 * @param {object} section
 * @param section.region
 * @param section.lang
 * @returns
 */
const StillHave = ({ section, region, lang }) => {
  let tabDesignHide =
    section?.sectionContent[1]?.titleDecoration === 'tab-hide' ||
    section?.sectionContent[6]?.titleDecoration === 'tab-hide' || section?.sectionContent[7]?.titleDecoration === 'tab-hide' ;
  // tabDesignHide = true;

  const CustomTab = forwardRef((props, ref) => {
    // 1. Reuse the `useTab` hook
    const tabProps = useTab({ ...props, ref });
    const isSelected = !!tabProps['aria-selected'];

    // 2. Hook into the Tabs `size`, `variant`, props
    const styles = useMultiStyleConfig('Tabs', tabProps);
    const Arrow = () => {
      return (
        <Box
          as="span"
          position="absolute"
          width="20px"
          display={isSelected ? 'block' : 'none'}
          height="11px"
          clipPath="polygon(0 0, 50% 100%, 100% 0)"
          left="50%"
          bottom="-10px"
          background="#CF4520"
          // animation={spinAnimation}
          style={{ transition: 'width 1s' }}
          // transform="rotate(45deg)"
          zIndex="0"
          transition="0.4s linear"
        ></Box>
      );
    };
    return (
      <Button
        __css={styles.tab}
        {...tabProps}
        width="50%"
        color={isSelected ? '#FFFFFF !important' : '#979797  !important'}
        bg={isSelected ? '#CF4520' : '#ECECEC'}
        border="0"
        fontFamily="FedraSansStd-book"
        fontStyle="normal"
        fontWeight="600"
        fontSize={{ base: '14px', md: '22.8514px' }}
        lineHeight="150.3%"
        _active={{ bg: '#CF4520', border: '0' }}
        _focus={{ bg: '#CF4520', border: '0' }}
        pos="relative"
        height={{ base: '45px', sm: '81px' }}
        p={{ base: '0', sm: '1rem' }}
      >
        {/* <Box as="span" mr="2" color={isSelected ? '#FFFFFF' : '#979797'}> */}
        {isSelected ? <Arrow /> : ''}
        {/* </Box> */}
        {tabProps.children}
      </Button>
    );
  });

  return (
    <MidContainer w={'970'}>
      <Box mt={{ base: '0px', md: '10px' }}>
        <SectionTitle titleObj={section?.sectionContent[0]} mt="0" />
        <Box w="100%" m="40px auto 0">
          <Tabs
            isFitted
            variant="enclosed"
            p="0"
            className="tabcontent"
            border={tabDesignHide ? 'none' : '3px solid #F0F0F0'}
            borderRadius="12px"
            paddingBottom="20px"
          >
            {!tabDesignHide && (
              <TabList borderBottom="none" mb="15px">
                <CustomTab style={{ borderRadius: '10px 0 0 0' }}>
                  {section?.sectionContent[6]?.titleText ||
                    section?.sectionContent[7]?.titleText}
                </CustomTab>
                {/* </Tab> */}
                <CustomTab style={{ borderRadius: '0 10px 0 0' }}>
                  {section?.sectionContent[1]?.titleText}
                </CustomTab>
              </TabList>
            )}
            <TabPanels m="0 auto">
              {section?.sectionContent[7]?.titleDecoration !== 'tab-hide' && (
                <TabPanel>
                  <MidContainer w="847">
                    {section?.sectionContent[8]?._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[8]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[9]?._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[9]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[10]?._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[10]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[11]?._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[11]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[12]?._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[12]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                  </MidContainer>
                </TabPanel>
              )}
              {section?.sectionContent[1]?.titleDecoration !== 'tab-hide' && (
                <TabPanel>
                  <MidContainer w="847">
                    {section?.sectionContent[2]._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[2]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[3]._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[3]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[4]._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[4]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[5]._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[5]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                    {section?.sectionContent[6]._modelApiKey ===
                      'faq_section_v2' && (
                      <Box mb="6px">
                        <FaqSectionV2
                          faqSection={section?.sectionContent[6]}
                          region={region}
                          lang={lang}
                          bgColor="#DED5C3"
                          color="#28231E"
                        />
                      </Box>
                    )}
                  </MidContainer>
                </TabPanel>
              )}
            </TabPanels>
          </Tabs>
        </Box>
        {section?.sectionContent[12]?._modelApiKey === 'simple_button' && (
          <Box
            mt={{ base: '0px', md: '15px' }}
            display="flex"
            placeContent="center"
          >
            <SimpleButton
              style={section?.sectionContent[12]}
              region={region}
              lang={lang}
              clickHandler={() =>
                window?.dataLayer?.push({ event: 'goy_register3' })
              }
            />
          </Box>
        )}
      </Box>
    </MidContainer>
  );
};

export default StillHave;
